<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <div>
      <div v-if="checkIncoming" class="position-absolute shadow-lg p-3 mb-5 bg-white rounded"
        style="right: 520px; top: 60px;  z-index: 1000">
        <div class="">
          <div v-if="!dialogAssignTicket" class="d-flex">
            <modal-create-ticket @create-done="createSussess" :sources="sources" :departments="departments"
              :objectFeedback="objectFeedback"></modal-create-ticket>
            <button class="btn btn-success font-weight-bold btn-sm ml-4" @click="dialogAssignTicket = true">
              <i class="fas fa-ticket-alt"></i>
              Gán ticket
            </button>
          </div>
          <div v-if="dialogAssignTicket">
            <h6>Gán cuộc gọi vào ticket</h6>
            <div class="p-4">
              <div>
                <label>Mã ticket</label>
              </div>
              <el-select v-model="formTicket.ticket_id" filterable clearable remote reserve-keyword
                placeholder="Nhập số mã ticket" :remote-method="remoteMethod" :loading="search_loading">
                <el-option v-for="item in dataFindTicket" :key="item.id" :label="changeTitle(item)" :value="item.id">
                  <span>{{ changeTitle(item) }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="mt-4 d-flex justify-content-end">
              <el-button class="" @click="dialogAssignTicket = false">Huỷ bỏ</el-button>
              <el-button class="bg-violet text-white" :disabled="loadingAssignee" v-loading="loadingAssignee"
                @click="assigneeTicket">Xác nhận</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 pb-1" v-show="checkChangeIcon" id="buttonCall">
        <div>
          <el-tooltip :content="isPopupOpen ? 'Tổng đài Zenify (Đang hoạt động)' : 'Mở tổng đài Zenify (Cửa sổ riêng)'" placement="bottom">
            <el-button
              :class="['border p-3 rounded position-relative', isPopupOpen ? 'border-success text-success bg-light-success' : 'border-dark']"
              @click="changeIcon"
            >
              <i class="el-icon-phone-outline"></i>
              <span v-if="isPopupOpen" class="zenify-topbar-dot"></span>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <!--begin: Search -->
    <b-dropdown size="sm" id="kt_quick_search_toggle" variant="link" toggle-class="topbar-item text-decoration-none"
      no-caret right no-flip>
      <template v-slot:button-content>
        <div class="btn btn-icon btn-clean btn-lg btn-dropdown mr-1">
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <inline-svg :src="publicPath + 'media/svg/icons/General/Search.svg'" />
          </span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <KTSearchDefault></KTSearchDefault>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Search -->

    <!--begin: Notifications -->
    <b-dropdown size="sm" variant="link" toggle-class="topbar-item text-decoration-none" no-caret right no-flip>
      <template v-slot:button-content>
        <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary">
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <inline-svg :src="publicPath + 'media/svg/icons/Code/Compiling.svg'" />
          </span>
          <span class="pulse-ring"></span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <KTDropdownNotification></KTDropdownNotification>
        </form>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Notifications -->

    <!--begin: Try Admin V2 -->
    <div class="topbar-item mr-2 d-flex align-items-center">
      <el-tooltip
        v-model="showV2Tooltip"
        content="Giao diện mới đã sẵn sàng — thử ngay version 2"
        placement="bottom"
        effect="dark"
        :manual="true"
      >
        <a
          class="btn btn-sm font-weight-bold try-admin-v2-btn"
          :href="adminV2Url"
          target="_blank"
          rel="noopener noreferrer"
          @click="dismissV2Tooltip"
        >
          <span class="try-admin-v2-btn__label d-none d-md-inline">Trải nghiệm version 2</span>
          <span class="try-admin-v2-btn__label d-inline d-md-none">V2 mới</span>
          <span class="try-admin-v2-btn__badge">Mới</span>
        </a>
      </el-tooltip>
    </div>
    <!--end: Try Admin V2 -->

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;

    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;

    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import KTSearchDefault from "@/view/layout/extras/dropdown/SearchDefault.vue";
import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
import KTDropdownQuickAction from "@/view/layout/extras/dropdown/DropdownQuickAction.vue";
import KTDropdownMyCart from "@/view/layout/extras/dropdown/DropdownMyCart.vue";
import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import KTQuickPanel from "@/view/layout/extras/offcanvas/QuickPanel.vue";
import i18nService from "@/core/services/i18n.service.js";
import {
  CHANGE_LOG_STRINGEE,
  CONNECT_STRINGEE, HANDLE_HISTORY_STRINGEE, REASON_ERROR,
  RELOAD_CONNECT_STRINGEE,
  UPDATE_HISTORY_STRINGEE, GET_SOURCE,
  GET_OBJECT_FEEDBACK, GET_ASSIGNEE_TICKET_STRINGEE
} from "../../../core/services/store/user/ticket.module";
import { GET_USER_BY_USER_PHONE } from "../../../core/services/store/user/users.module";
import ModalCreateTicket from "../../pages/crm/tickets/components/ModalCreateTicket";
import { GET_DEPARTMENT } from "../../../core/services/store/user/department.module";
import { mapState, mapActions } from 'vuex'
import { ADMIN_V2_URL } from "@/view/layout/header/adminV2";
import { openZenifyPopup, subscribeZenifyMessages, sendZenifyMessage, isZenifyPopupActive } from "@/core/services/zenifyChannel";

export default {
  name: "KTTopbar",
  data() {
    return {
      publicPath: process.env.VUE_APP_BASE_URL,
      languageFlag: "",
      languages: i18nService.languages,
      //
      config: {
        showMode: 'disable',
        top: 60,
        right: 200,
        arrowLeft: 155,
        arrowDisplay: 'top',
        fromNumbers: [
          { alias: 'Number-1', number: '+84899199586' },
          { alias: 'Number-2', number: '+2222' }
        ],
        askCallTypeWhenMakeCall: false,
        appendToElement: null,
        makeAndReceiveCallInNewPopupWindow: false,
      },
      accessToken: '',
      numbers: '',
      fromNumber: '',
      toNumber: '',
      callType: '',
      checkIncoming: false,
      messageError: '',
      reasonError: REASON_ERROR,
      userByPhone: {},
      dialogCreateTicket: false,
      dialogAssignTicket: false,
      sources: [],
      departments: [],
      formTicket: {
        ticket_id: '',
      },
      access_token: '',
      loadingAssignee: false,
      checkChangeIcon: true,
      objectFeedback: [],
      dataFindTicket: {},
      search_loading: false,
      category_chamsoc_define: {
        1: 'Nghỉ học 2 buổi',
        2: 'Điểm kiểm tra thấp',
        3: 'Không làm bài',
        4: 'Chua đóng tiền học',
        5: 'Đã đóng tiền học',
        6: 'Feedback thấp',
        7: 'Nghỉ học 1 buổi',
        8: 'Nghỉ học 1 buổi',
        9: 'Hướng dẫn app cho phụ huynh',
        10: 'Kết quả BTVN không tốt',
        11: 'Không làm BTVN'
      },
      phone: '',
      adminV2Url: ADMIN_V2_URL,
      showV2Tooltip: false,
      adminV2TooltipKey: 'admin_v2_try_tooltip_dismissed',
      isPopupOpen: false,
      unsubscribeZenify: null
    };
  },
  components: {
    KTSearchDefault,
    KTDropdownNotification,
    KTDropdownQuickAction,
    KTDropdownMyCart,
    KTDropdownLanguage,
    KTQuickUser,
    KTQuickPanel,
    ModalCreateTicket
  },
  mounted() {
    this.getSource();
    this.getObjectFeedback();
    this.getDepartments();
    this.$nextTick(() => {
      if (!localStorage.getItem(this.adminV2TooltipKey)) {
        this.showV2Tooltip = true;
        this._v2TooltipTimer = setTimeout(() => {
          this.dismissV2Tooltip();
        }, 6000);
      }
    });

    this.unsubscribeZenify = subscribeZenifyMessages((msg) => {
      if (msg.type === 'PONG') {
        this.isPopupOpen = true;
      } else if (msg.type === 'POPUP_CLOSED') {
        this.isPopupOpen = false;
        this.checkIncoming = false;
      } else if (msg.type === 'INCOMING_CALL') {
        this.callStringeeId = msg.callId || '';
        this.checkIncoming = true;
        this.$notify({
          title: 'Cuộc gọi đến (Zenify)',
          message: `Có cuộc gọi đến từ ${msg.caller}. Bấm vào đây để mở tổng đài.`,
          type: 'warning',
          duration: 12000,
          position: 'top-right',
          onClick: () => {
            openZenifyPopup();
          }
        });
      } else if (msg.type === 'CALL_ENDED') {
        this.checkIncoming = false;
      }
    });
    // Ping kiểm tra trạng thái popup
    sendZenifyMessage({ type: 'PING' });
  },
  beforeDestroy() {
    if (this._v2TooltipTimer) {
      clearTimeout(this._v2TooltipTimer);
    }
    if (this.unsubscribeZenify) {
      this.unsubscribeZenify();
    }
  },
  methods: {
    ...mapActions('zenify', ['close', 'openWithPhone', 'open']),

    dismissV2Tooltip() {
      this.showV2Tooltip = false;
      localStorage.setItem(this.adminV2TooltipKey, '1');
      if (this._v2TooltipTimer) {
        clearTimeout(this._v2TooltipTimer);
        this._v2TooltipTimer = null;
      }
    },

    getDepartments() {
      this.$store.dispatch(GET_DEPARTMENT, {
        all: true,
        status: 1
      }).then((data) => {
        this.departments = data.data;
      })
    },
    getObjectFeedback() {
      this.objectFeedback = [];
      this.$store.dispatch(GET_OBJECT_FEEDBACK).then((data) => {
        for (const key in data.data) {
          this.objectFeedback.push({
            id: key,
            name: data.data[key]
          })
        }
      })
    },
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },


    changeIcon() {
      if (this.isPopupOpen || isZenifyPopupActive()) {
        sendZenifyMessage({ type: 'FOCUS' });
        this.$notify({
          title: 'Tổng đài Zenify',
          message: 'Cửa sổ tổng đài Zenify đã đang được mở.',
          type: 'info',
          duration: 3000,
          position: 'top-right'
        });
        return;
      }
      openZenifyPopup();
    },
    createSussess(data) {
      this.formTicket.ticket_id = data.id;
      this.dataFindTicket = [data];
      this.assigneeTicket();
    },
    assigneeTicket() {
      if (!this.dataFindTicket.length) {
        this.$bvToast.toast('Không tìm thấy ticket để gán', {
          title: 'Không tìm thấy ticket để gán',
          variant: 'danger',
          solid: true
        });
        return;
      }
      this.loadingAssignee = true;
      let payload = {};
      payload.ticket_id = this.formTicket.ticket_id;
      payload.fromNumber = this.fromNumber;
      payload.toNumber = this.toNumber;
      payload.callType = this.callType;
      payload.callId = this.callStringeeId;
      this.$store.dispatch(CHANGE_LOG_STRINGEE, payload).then((res) => {
        this.dialogAssignTicket = false;
        this.$bvToast.toast('Gán ticket thành công', {
          title: 'Gán ticket thành công',
          variant: 'success',
          solid: true
        });
        this.loadingAssignee = false;
        const checkTicket = this.dataFindTicket.find(item => item.is_auto == 3);
        if (checkTicket) {
          this.$router.push({ name: 'crm-ticket-show', params: { id: this.formTicket.ticket_id } })
        } else {
          this.$router.push({ name: 'ticket-show', params: { id: this.formTicket.ticket_id } })
        }
      })
    },
    remoteMethod(query) {
      this.search_loading = true;
      this.$store.dispatch(GET_ASSIGNEE_TICKET_STRINGEE, { ticket_id: query }).then((data) => {
        this.dataFindTicket = data.data;
        this.search_loading = false;
      })

    },
    changeTitle(ticket) {
      let category = '';
      if (ticket.category_ticket) {
        category = ticket.category_ticket.name;
      } else {
        category = this.category_chamsoc_define[ticket.category_chamsoc];
      }
      return category ? ticket.id + ' - ' + category : 'Không có bản ghi';
      // return ticket.category_chamsoc ? ticket.id + '-' + this.category_chamsoc_define[ticket.category_chamsoc] : (ticket.id ? ticket.id + ' - ' + (ticket.category_ticket ?? 'Không có bản ghi');
    },
    getSource() {
      this.sources = [];
      this.$store.dispatch(GET_SOURCE).then((data) => {
        for (const key in data.data) {
          this.sources.push({
            id: key,
            name: data.data[key]
          })
        }
      })
    },
    changeShowDialer(value)
    {
      this.close();

    },

    closePhone() {
      this.openWithPhone('');
      this.phone = '';
    },
    appendNumber(num) {
      if (this.phone.length >= 10) return;
      this.phone += num;
      this.openWithPhone(this.phone);

    },
    changePhone(value)
    {
      this.showCall = true;
      this.phone = value;
      this.openWithPhone(this.phone);

    }
  },
  computed: {
    ...mapState('zenify', ['isOpen', 'phoneCall']),
    getLanguageFlag() {
      return this.onLanguageChanged();
    }
  }
};
</script>
<style>
.show {
  display: block;
}

.hide {
  display: none;
}

.bg-violet {
  background: #5E00B6;
}

.try-admin-v2-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  background: #0d9488;
  color: #fff !important;
  border: none;
  line-height: 1.2;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(13, 148, 136, 0.35);
  transition: background 0.15s ease, transform 0.15s ease;
}
.try-admin-v2-btn:hover,
.try-admin-v2-btn:focus {
  background: #0f766e;
  color: #fff !important;
  text-decoration: none;
  transform: translateY(-1px);
}
.try-admin-v2-btn__badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 10px;
  background: #fbbf24;
  color: #78350f;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.zenify-topbar-dot {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #10b981;
  box-shadow: 0 0 0 2px #ffffff;
}

.bg-light-success {
  background-color: #ecfdf5 !important;
}
</style>
